import { FullScreenLoading } from '@backrs_ui/common-ui';

import { useIsInstitutionAdmin } from '@backrs_ui/grow-ui/src/hooks/useIsInstitutionAdmin';
import {
  selectIsFeatureFlagEnabled,
  FEATURE_FLAGS,
} from '@backrs_ui/grow-ui/src/redux/featureFlags/featureFlags';
import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import { selectUser } from '@backrs_ui/grow-ui/src/redux/user/user';
import { useFetchUserPermissionsQuery } from '@backrs_ui/grow-ui/src/redux/user/user.api';
import { UI_PERMISSIONS } from '@backrs_ui/grow-ui/src/redux/user/user.transformer';

import { SettingsPage } from './SettingsPage';

export const SettingsPageContainer = () => {
  const user = useAppSelector(selectUser);
  const { data: userPermissions } = useFetchUserPermissionsQuery(undefined);
  const isGrowPaywallEnabled = useAppSelector(
    selectIsFeatureFlagEnabled(FEATURE_FLAGS.GROW_PAYWALL),
  );
  const isInstitutionAdmin = useIsInstitutionAdmin();

  if (!user) {
    return <FullScreenLoading />;
  }

  const enableFamilyTab = userPermissions?.[UI_PERMISSIONS.HAS_FAMILY_ACCESS]?.allowed === true;

  return (
    <SettingsPage
      user={user}
      enableBillingTab={isGrowPaywallEnabled}
      enableFamilyTab={!!enableFamilyTab}
      enableSeatsTab={isInstitutionAdmin}
    />
  );
};
